
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.455 5.364h29.091a1.455 1.455 0 00-.001-2.91H2.455a1.456 1.456 0 000 2.91zm29.09 23.272H2.455a1.455 1.455 0 000 2.91h29.091a1.455 1.455 0 10-.001-2.91zm0-13.091H2.455a1.455 1.455 0 000 2.91h29.091a1.455 1.455 0 00-.001-2.91z"}})])
          )
        }
      }
    